import React from 'react';

import SubscriptionForm from '@components/SubscriptionForm';
import { AppContextProvider } from '@contexts/AppContext';
import { SubscribeFormProvider } from '@contexts/SubscribeFormContext';
import { User } from '@utils/backend-api/currentUser';
import { SelectedOffer } from '@utils/backend-api/subscribe';

import PlanOptions from './PlanOptions';

interface ReferralSubscriptionProps {
  initialCurrentUser?: User;
  isGdprRequired: boolean;
  referralOffer: SelectedOffer;
  referringSubGuid: string;
  referringSubName: string;
  stripeCustomerId?: string;
  userEmail?: string;
  userFullName?: string;
}

const Subscription = ({
  initialCurrentUser,
  isGdprRequired,
  referralOffer,
  referringSubGuid,
  referringSubName,
  stripeCustomerId,
  userEmail,
  userFullName,
}: ReferralSubscriptionProps) => {
  return (
    <AppContextProvider initialCurrentUser={initialCurrentUser} isGdprRequired={isGdprRequired}>
      <SubscribeFormProvider user={{ email: userEmail, name: userFullName, stripeCustomerId }}>
        <PlanOptions referralOffer={referralOffer} referringSubName={referringSubName} />
        <div className="mx-auto w-full px-12 sm:w-8/12 lg:w-6/12">
          <SubscriptionForm
            formLocation="referral_subscribe"
            buttonText="Subscribe"
            selectedOffer={referralOffer}
            presentedOfferCodes={[referralOffer.code]}
            referringSubscriberGuid={referringSubGuid}
            referringSubscriberName={referringSubName}
          />
        </div>
      </SubscribeFormProvider>
    </AppContextProvider>
  );
};

export default Subscription;
